import { createPhaseAction } from 'src/helpers/redux'
import { IGetAccounts } from 'src/services/accounts'

export const PREFIX = 'account'
export const SAGA = `${PREFIX}/saga`

import * as usersAuthService from 'src/services/auth/users'
import * as oauthService from 'src/services/auth/oauth'
// import * as partnerAuthService from 'src/services/auth/partner'
import { IUserData } from 'src/services/auth/users'

export const actions = {
  session: createPhaseAction<void>(`${SAGA}/session`),

  login: createPhaseAction<usersAuthService.ILoginParams>(`${SAGA}/login`),
  getOauthClients: createPhaseAction<oauthService.IGetOauthClients>(
    `${SAGA}/getOauthClients`
  ),
  postOauthLogin: createPhaseAction<oauthService.IPostOauthClients>(
    `${SAGA}/postOauthLogin`
  ),
  getOauthAuthorize: createPhaseAction<oauthService.IOauthAuthorizeParams>(
    `${SAGA}/getOauthAuthorize`
  ),
  postOauthToken: createPhaseAction<oauthService.IOauthTokenRequest>(
    `${SAGA}/postOauthToken`
  ),

  recoverPassword: createPhaseAction<usersAuthService.IRecoverPassword>(
    `${SAGA}/recoverPassword`
  ),
  resetPassword: createPhaseAction<usersAuthService.IResetPassword>(
    `${SAGA}/resetPassword`
  ),

  getRefreshToken: createPhaseAction<{ isUpdatePermissions?: boolean }>(
    `${SAGA}/getRefreshToken`
  ),

  getProfile: createPhaseAction<void>(`${SAGA}/profile`),

  logout: createPhaseAction<void>(`${SAGA}/logout`),

  getAccounts: createPhaseAction<IGetAccounts>(`${SAGA}/getAccounts`),

  toggleUsersStatus: createPhaseAction<usersAuthService.IToggleStatusUser>(
    `${SAGA}/toggleUsersStatus`
  ),

  getAllUsersSearch: createPhaseAction<usersAuthService.IGetAllUsers>(
    `${SAGA}/getAllUsersSearch`
  ),

  loadMoreUsersSearch: createPhaseAction<usersAuthService.IGetAllUsers>(
    `${SAGA}/loadMoreUsersSearch`
  ),
  getAllUsers: createPhaseAction<usersAuthService.IGetAllUsers>(
    `${SAGA}/getAllUsers`
  ),

  loadMoreUsers: createPhaseAction<usersAuthService.IGetAllUsers>(
    `${SAGA}/loadMoreUsers`
  ),

  getRoles: createPhaseAction(`${SAGA}/getRoles`),

  editUser: createPhaseAction<IUserData>(`${SAGA}/editUser`),

  editProfile: createPhaseAction<usersAuthService.IGetUserDataInfo>(
    `${SAGA}/editProfileData`
  ),
  editProfileAvatar: createPhaseAction<{ avatar: File | string }>(
    `${SAGA}/editProfileAvatar`
  ),

  inviteUsers: createPhaseAction<usersAuthService.IInviteUsers>(
    `${SAGA}/inviteUsers`
  ),

  getBillingStat:
    createPhaseAction<void /*partnerAuthService.IBillingStatParams*/>(
      `${SAGA}/getBillingStat`
    ),

  getPartnerCheck: createPhaseAction<void>(`${SAGA}/getPartnerCheck`),
}

export type Actions = typeof actions
